module.exports = __webpack_public_path__ + "static/media/pps.76b71252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pps.png
// module id = 2295
// module chunks = 0